{
	"content": {
		"title": "Изберете материалите, за които са необходими декларации",
		"materialListLabel": "Материал",
		"materialQuantityLabel": "Количество материал ({{unit}})",
		"availableQuantityLabel": "Налично количество ({{unit}})",
		"carbonSavingsLabel": "Въглеродни редукции ({{unit}} CO₂ eq.)"
	},
	"summary": {
		"title": "Обобщение",
		"declarationTypeTitle": "Тип декларация",
		"customerProjectTitle": "Проект на клиента",
		"internalProjectOrProductTitle": "Вътрешен проект / продукт",
		"projectReferenceTitle": "Референция на проект",
		"materialHeaderTitle": "Материал",
		"quantityHeaderTitle": "Количество ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Разпределими въглеродни редукции ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Неразпределими въглеродни редукции ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Количеството е задължително",
		"quantityPositive": "Моля, въведете положително количество.",
		"quantityLargerThanAvailable": "Моля, намалете количеството до общото налично",
		"savingsRequired": "Въглеродните редукции са задължителни",
		"fetchNotTransferedMaterialsError": "Неуспешно извличане на непрехвърлени материали"
	},
	"submitTitle": "Добави към проект",
	"backTitle": "Назад"
}
